const PROGRAM_INVITATION_PATH = /^\/programs\/[^/]+\/invitations\/[^/]+\/?$/;

/**
 * Whether a path is a program invitation page
 *
 * @param path - The pathname without query string
 * @returns True when the path is `/programs/:id/invitations/:invitationId`
 */
export const isProgramInvitationPath = (
	path: string | null | undefined,
): boolean => !!path && PROGRAM_INVITATION_PATH.test(path);
